const URL = "https://spektor1.myvnc.com:11500";
export default URL;
